// extracted by mini-css-extract-plugin
export default {"Edit":"Edit_Edit__juEcf","Top":"Edit_Top__pIDQ8","Logo":"Edit_Logo__NDfkH","File":"Edit_File__h0nQb"};